import React from 'react';
import styled from 'styled-components';
import { useIntl } from '@utils/localize';

import colors from '@utils/colors';
import { Body, Heading } from '@components/type';

const Title = styled(Heading)`
  margin-bottom: 16px;
  color: ${colors.B500};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10vh 24px 5vh;
  text-align: center;
`;

const EmptyState = () => {
  const intl = useIntl();

  return (
    <Wrapper>
      <Title level={100}>{intl.messages['emptyState.noResults']}</Title>
      <Body sizes={['small', 'regular']}>
        {intl.messages['emptyState.tryAgain']}
      </Body>
    </Wrapper>
  );
};

export default EmptyState;
